var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"modal-header\"\u003E\u003Cspan class=\"close-btn header\" ng-click=\"$close()\"\u003E\u003C\u002Fspan\u003E\u003Ch4\u003EHírlevél leiratkozás\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-body subscribe\"\u003E\u003Cspan class=\"icon fail\"\u003E&nbsp;\u003C\u002Fspan\u003E\u003Ch3\u003EA hírlevélről leiratkozás sikeres, többet nem kap tőlünk hírlevelet\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./source/applications/hirlevel/sikeres-leiratkozas-popup.pug
// module id = 100
// module chunks = 0